import { Injectable } from "@angular/core";
import { SwiperContainer } from "swiper/swiper-element";
import Swiper from "swiper";
// @ts-ignore
import { SwiperOptions } from "swiper/types";
import { SliderAyOptions } from "@shared-ay/slider-web-ay/slider-web-ay.component";

@Injectable()
export class SliderWebAyService {
	constructor() {}

	initSwiper(swiperElement: SwiperContainer, sliderRefName: string, options?: SliderAyOptions): Swiper {
		const params = this.defaultParams(sliderRefName, options?.bulletIndex ?? false);
		//fill custom options
		this.fillCustomOption(params, options);
		Object.assign(swiperElement, params);
		swiperElement.initialize();
		return swiperElement.swiper;
	}

	defaultParams(sliderRefName: string, withIndex: boolean) {
		const swiperParams: SwiperOptions = {
			slidesPerView: 1,
			mousewheel: true,
			pagination: {
				enabled: true,
				clickable: true,
				el: `.${sliderRefName} .swiper-pagination-custom`,
				renderBullet: (index, className) => this.renderBullet(withIndex, index, className),
			},
			navigation: {
				prevEl: `.${sliderRefName} .prev-btn`,
				nextEl: `.${sliderRefName} .next-btn`,
			},
			on: {
				init() {},
			},
		};
		return swiperParams;
	}

	private renderBullet(withIndex: boolean, index: any, className: any) {
		return `<span class="${withIndex ? "swiper-pagination-index" : ""}  ${className} ">${
			withIndex ? index + 1 : ""
		}</span>`;
	}

	private fillCustomOption(swiperOptions: SwiperOptions, options: SliderAyOptions) {
		if (options) {
			swiperOptions.mousewheel = options?.mouseWheel ?? swiperOptions.mousewheel;
			swiperOptions.slidesPerView = options.slidesPerView ?? swiperOptions.slidesPerView;
		}
	}
}
